import { colors } from '@alixpartners/ui-components';
import {
	getFormattedPercentage,
	getFormattedSpendWithSymbol,
} from 'utils/number';

export const FONTSTYLE = {
	fontSize: '11px',
	fontWeight: '400',
	lineHeight: '13px',
	letterSpacing: 0,
	color: colors.grey7,
};

export const CHART_COLORS = [
	colors.chartDarkBlue,
	colors.chartBrightTeal,
	colors.chartMediumGrey,
	colors.chartOrange,
	colors.chartDarkGreen,
	colors.chartDarkTeal,
	colors.chartLightBlue,
	colors.chartDarkGrey,
	colors.chartLightOrange,
	'#43AD80',
];

export const getSeriesData = (data, key) => {
	if (!data || data.length === 0) {
		return [];
	}
	return data.map(item => item[key]);
};

export const getCategories = (data, key) => {
	if (!data || data.length === 0) {
		return [];
	}
	return data.map(item => (item[key] === null ? 'N/A' : item[key]));
};

export const spendFormatter = (value, withZero) => {
	const currencySymbol = '$';
	return value || withZero
		? getFormattedSpendWithSymbol(value, currencySymbol, true).toUpperCase()
		: '-';
};

export const chartheight = '60%';

export const percentFormatter = value => {
	return getFormattedPercentage(value).toUpperCase();
};
